module.exports = __webpack_public_path__ + "assets/static/png/hosting-grey.18415190ddc9fd9d125d743b3b9d5054.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/hosting-grey.png
 ** module id = 507
 ** module chunks = 1
 **/